// extracted by mini-css-extract-plugin
module.exports = {"EmptyState":"empty_state_EmptyState__eQGhh","illustration":"empty_state_illustration__cnHGT","details":"empty_state_details__Wg-jA"};